import { useFetchSlaConfig } from '@/shared/actions/erp/tickets-soporte-cliente/gestion-tickets-configuracion.actions';

export function useSlaEnabled(): { slaEnabled: boolean; isLoading: boolean } {
  const { data, isLoading } = useFetchSlaConfig();
  const slaEnabled = (data as any)?.data?.sla_habilitado ?? true;
  return { slaEnabled, isLoading };
}
